var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.199,
    height: 18,
    viewBox: "0 0 22.199 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-cloud",
    d: "M9.231,7.967a4.992,4.992,0,0,1,4.882-2.423,3.786,3.786,0,0,1,3.607,3.342,1.038,1.038,0,0,0,1.033.906c1.907,0,3.11,1.458,3.331,3.361a3.92,3.92,0,0,1-2.208,4.287H16.8a1.034,1.034,0,1,0,0,2.068h3.259a1.047,1.047,0,0,0,.329-.053,5.941,5.941,0,0,0,3.766-6.538,5.569,5.569,0,0,0-4.528-5.127,5.893,5.893,0,0,0-5.3-4.3A7.157,7.157,0,0,0,7.947,6.15a3.229,3.229,0,0,0-3.28.893,3.5,3.5,0,0,0-.887,3.248,5.129,5.129,0,0,0-1.75,4.583,5.26,5.26,0,0,0,3.355,4.579,1.047,1.047,0,0,0,.329.053H8.974a1.034,1.034,0,1,0,0-2.068H5.9a3.271,3.271,0,0,1-1.8-2.772A2.89,2.89,0,0,1,5.52,11.633a1.03,1.03,0,0,0,.444-1.446,1.415,1.415,0,0,1,.21-1.718,1.151,1.151,0,0,1,1.571-.146,1.044,1.044,0,0,0,1.487-.357Zm4.391,2.651-.736-.731-.736.731L8.89,13.856a1.029,1.029,0,0,0,0,1.462,1.046,1.046,0,0,0,1.472,0l1.483-1.474v6.572a1.041,1.041,0,0,0,2.081,0V13.845l1.483,1.474a1.045,1.045,0,0,0,1.472,0,1.029,1.029,0,0,0,0-1.462Z",
    transform: "translate(-2 -3.45)",
    fill: "#deb851",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.c0406f44edfcc7909b51f88317b5be9d.svg";
export { ForwardRef as ReactComponent };